import { IRaffle } from "../interfaces/IRaffle";

export const RaffleStateDefault: IRaffle = {
     id: "default",
     accountId: 'default',
     availablePaymentMethods: [],
     awards: [],
     limit: 0,
     name: "default",
     status: "default",
     ticketPrice: 0,
     createdDate: new Date().toISOString(),
     ticketPriceUSD: 0,
     type: "raffle",
     sorterId: "default",
     bankAccounts: [],
     paymentProd: false,
     isPremium: false,
     hasReferenceNumber: false,
     templateId: 'default',
};
